// extracted by mini-css-extract-plugin
export default {"items":"CartItem_items__KGiIw","itemsPrice":"CartItem_itemsPrice__PnRZB","info":"CartItem_info__XX9df","remove":"CartItem_remove__NKswk"};